"use client";

import React from "react";
import { Wrench, ShieldCheck, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reasons = [{
  id: "01",
  title: "فريق من الخبراء",
  description: "نمتلك نخبة من الفنيين المتخصصين المدربين على أحدث تقنيات مكافحة الحشرات لضمان القضاء التام والنهائي.",
  icon: Users,
  className: "md:col-span-2"
}, {
  id: "02",
  title: "ضمان طويل الأمد",
  description: "نقدم ضمانات حقيقية وموثقة على كافة خدماتنا، مع زيارات دورية مجانية.",
  icon: ShieldCheck,
  className: "md:col-span-1"
}, {
  id: "03",
  title: "معدات متطورة",
  description: "نستخدم أحدث أجهزة الرش والمواد الألمانية الصديقة للبيئة والآمنة تماماً.",
  icon: Wrench,
  className: "md:col-span-1"
}, {
  id: "04",
  title: "حلول ذكية",
  description: "نطبق استراتيجيات متكاملة تعتمد على دراسة سلوك الآفات لضمان عدم عودتها مجدداً.",
  icon: ShieldCheck,
  className: "md:col-span-2"
}];
export default function WhySellWithUs() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222978" id="لماذا-يختارنا-العملاء" className="bg-[var(--color-primary)] text-[var(--text-light)] py-16 md:py-20 lg:py-24 px-4 sm:px-6 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 w-[70%] sm:w-[65%] lg:w-[600px] h-[600px] bg-[var(--color-accent)]/10 blur-[150px] rounded-full pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[70%] sm:w-[65%] lg:w-[600px] h-[600px] bg-[var(--color-accent)]/5 blur-[150px] rounded-full pointer-events-none" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-block px-4 py-1.5 mb-6 rounded-full border border-[var(--color-accent)]/20 bg-[var(--color-accent)]/10 backdrop-blur-sm">
            <span className="text-[var(--color-accent)] text-sm font-bold tracking-wider uppercase">لماذا سرايا؟</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 tracking-tight text-[var(--text-light)]">
            نضع معايير جديدة <span className="text-[var(--color-accent)]">للجودة والأمان</span>
          </h2>
          <p className="text-[var(--muted-foreground)] text-lg md:text-xl max-w-3xl mx-auto leading-relaxed">
            في شركة سرايا، نجمع بين الخبرة الفنية والالتزام التام بمعايير السلامة العالمية لنمنحك بيئة نظيفة وخالية من الحشرات باستخدام أحدث التقنيات الألمانية.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {reasons.map((reason, i) => <div key={i} data-index={i} className={`relative flex flex-col p-8 rounded-lg bg-[var(--color-secondary)]/40 border border-[var(--text-light)]/10 backdrop-blur-md group hover:border-[var(--color-accent)]/40 transition-all duration-500 ${reason.className}`}>
              <div className="flex justify-between items-start mb-6">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-[var(--color-primary)] border border-[var(--text-light)]/10 transition-all duration-500 group-hover:scale-110 group-hover:border-[var(--color-accent)]/50 group-hover:shadow-lg group-hover:shadow-[var(--color-accent)]/10">
                  <reason.icon className="w-6 h-6 text-[var(--color-accent)] stroke-[1.5]" />
                </div>
                <span className="text-3xl font-bold text-[var(--text-light)]/5 font-mono group-hover:text-[var(--color-accent)]/20 transition-colors duration-500">
                  {reason.id}
                </span>
              </div>
              
              <div className="relative z-10">
                <h3 className="text-2xl font-bold mb-3 text-[var(--text-light)] tracking-tight">
                  {reason.title}
                </h3>
                <p className="text-[var(--muted-foreground)] leading-relaxed text-base group-hover:text-[var(--text-light)]/90 transition-colors duration-500">
                  {reason.description}
                </p>
              </div>

              {}
              <div className="absolute bottom-0 right-0 w-0 h-0 border-b-2 border-r-2 border-[var(--color-accent)]/0 group-hover:border-[var(--color-accent)]/40 group-hover:w-6 group-hover:h-6 transition-all duration-500 rounded-br-lg" />
            </div>)}

          {}
          <div className="hidden md:flex relative overflow-hidden rounded-lg border border-[var(--text-light)]/10 group">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/pest_control_tech.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/pest_control_tech.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661713/img/pest_control_tech.png-wvc-sizes" alt="Pest Control Technology" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--color-primary)] via-[var(--color-primary)]/40 to-transparent opacity-80" />
            <div className="relative z-10 mt-auto p-8">
              <p className="text-[var(--color-accent)] font-bold text-sm mb-2">تقنيات متطورة</p>
              <h4 className="text-[var(--text-light)] font-bold text-xl">نستخدم أحدث الأجهزة الألمانية</h4>
            </div>
          </div>
        </div>

        <div ref={ctaRef} className={`mt-16 text-center transition-all duration-1000 delay-400 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="h-14 px-12 text-lg font-bold rounded-full shadow-lg shadow-[var(--color-accent)]/10 hover:shadow-xl hover:shadow-[var(--color-accent)]/20 transition-all duration-300 bg-[var(--color-accent)] text-[var(--color-primary)] hover:bg-[var(--color-accent)]/90 border-none">
            <Link to="/HomePage">اطلب معاينة مجانية الآن</Link>
          </Button>
        </div>
      </div>
    </section>;
}